








import Vue from 'vue'
import Component from 'vue-class-component'
import SideBar from '@/components/SideBar.vue'

@Component({
  components: {
    SideBar
  }
})
export default class Milestones extends Vue {
  get tabs () {
    return [{
      label: 'Chains Milestones',
      icon: '',
      to: { name: 'admin-chains-milestones' }
    }, {
      label: 'Users Milestones',
      icon: '',
      to: { name: 'admin-users-milestones' }
    }]
  }
}
